import React from "react";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { MANAGEMENT_ACTION_ICON_BUTTON_SIZE } from "../../styles/managementCardActions";
import { lightTheme } from "../../styles/theme";

/** An icon-only row action, like Family's report cards: the label shows on hover. */
const CertificatesIconButton: React.FC<{
  label: string;
  danger?: boolean;
  /** Shows a spinner in place of the icon, and can't be pressed again. */
  loading?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}> = ({ label, danger, loading, onClick, children }) => (
  <Tooltip title={label}>
    {/* The span keeps the tooltip working while the button is disabled. */}
    <span>
      <IconButton
        size={MANAGEMENT_ACTION_ICON_BUTTON_SIZE}
        aria-label={label}
        aria-busy={loading || undefined}
        disabled={loading}
        onClick={onClick}
        sx={{
          color: danger ? lightTheme.colors.error : lightTheme.colors.primary,
        }}
      >
        {loading ? <CircularProgress size={18} color="inherit" /> : children}
      </IconButton>
    </span>
  </Tooltip>
);

export default CertificatesIconButton;
